import { BikeleasingContractListItemDTOStatusEnum } from 'probonio-shared-ui/api';

export function getBikeleasingEmployeeContractStatusColor(status?: BikeleasingContractListItemDTOStatusEnum) {
  switch (status) {
    case BikeleasingContractListItemDTOStatusEnum.Active:
      return 'success';
    case BikeleasingContractListItemDTOStatusEnum.Expiring:
    case BikeleasingContractListItemDTOStatusEnum.EmployeeApprovalRequired:
    case BikeleasingContractListItemDTOStatusEnum.BikeTransferRequired:
      return 'warning';
    case BikeleasingContractListItemDTOStatusEnum.BikeShipped:
    case BikeleasingContractListItemDTOStatusEnum.BikeTransferDone:
    case BikeleasingContractListItemDTOStatusEnum.EmployerApprovalRequired:
    case BikeleasingContractListItemDTOStatusEnum.EmployerApprovalDone:
    case BikeleasingContractListItemDTOStatusEnum.Requested:
      return 'info';
    case BikeleasingContractListItemDTOStatusEnum.Finished:
      return 'default';
    case BikeleasingContractListItemDTOStatusEnum.CancelledOrRejected:
    default:
      return 'error';
  }
}
